import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import HeroPresenter from "presenters/HeroPresenter";
import Placeholder from "components/Placeholder";
import LazyLoad from "components/LazyLoad";

import { Background, StyledLink, StyledResponsiveImage } from "./styles";

const Banner = ({ hero, loading = false }) => {
  const mainImage = HeroPresenter.mainImage(hero);
  const backgroundImage = HeroPresenter.backgroundImage(hero);
  const backgroundColor = HeroPresenter.backgroundColor(hero);
  const altText = HeroPresenter.altText(hero) ?? document.title;
  const link = HeroPresenter.link(hero);

  if (loading)
    return (
      <Placeholder data-testid="placeholder" variant="rect" sx={{ paddingTop: "22.5%", margin: [0, "auto", 40] }} />
    );
  if (!mainImage) return null;

  return (
    <Background backgroundImage={backgroundImage} backgroundColor={backgroundColor} data-testid="banner-container">
      {link ? (
        <StyledLink to={link} component={NavLink}>
          <LazyLoad lazy>
            <StyledResponsiveImage src={mainImage} alt={altText} width={1600} widthMobile={780} />
          </LazyLoad>
        </StyledLink>
      ) : (
        <LazyLoad lazy>
          <StyledResponsiveImage src={mainImage} alt={altText} width={1600} widthMobile={780} />
        </LazyLoad>
      )}
    </Background>
  );
};

Banner.propTypes = {
  hero: HeroPresenter.shape(),
  loading: PropTypes.bool,
};

export default Banner;
